import React, {useEffect, useState} from 'react';
import {
    CourseOrderLocalItemResult,
    WorkFlowTaskRequest
} from "../../../../../../../services/courseOrder/models/CourseOrderType";
import Accordion from "../../../../../../../components/blocks/Accordion";
import {useTranslation} from "react-i18next";
import AccordionItem from "../../../../../../../components/blocks/Accordion/AccordionItem";
import LookupDropdown from "../../../../../../../components/blocks/LookupDropdown";

import {TaskActionsNames} from "../../../../../../../services/shared-models/sharedTypes";
import {OpenPublishingTaskResult} from "../../../../../../../services/tasks/models/tasksTypes";
import {BackendServices} from "../../../../../../../services";
import {useParams} from "react-router-dom";



type CenterManagerSelectProps = {
    order:CourseOrderLocalItemResult | null;
    submitRef:any;
}

function CenterManagerSelect({order,submitRef}:CenterManagerSelectProps) {
    const { serialGID } = useParams();
    const [centreManagementId, setCentreManagementId] = useState<number|null>(null)
    const [error, setError] = useState<string>("")
    useEffect(() => {
        if(order){
            setCentreManagementId(order?.centreManagementId??0);
        }
    }, [order]);
    const { t } = useTranslation("Orders");


    useEffect(() => {
        // Set the value of submitRef with the submit method
        if(centreManagementId==0)
            setError("invalidValue");
        else
            setError("");
        
        submitRef.current = {
            globalSubmit:async (actionName: TaskActionsNames,openTask: OpenPublishingTaskResult | null,notes?:string ) :Promise<boolean>=>{
                if(actionName ==="Approve")
                {
                   const res= await BackendServices.courseOrderService.UpdateCenterManager(order?.id??0, {
                        centreManagementId:centreManagementId,
                        workFlowTaskRequest:{
                            actionName:actionName,
                            notes:notes??"",
                            serialGuid: serialGID ??"",
                            activityGuid: openTask?.activityGuid??""
                        }
                    });
                    if(res.hasError)
                    {
                        console.log(res.description);
                    }
                    return true;
                }
                return false;
         
                

            }
        };
    },[centreManagementId]);
 
    
    return (
        <Accordion>
            <AccordionItem initiallyOpen title={t("PublishingUnit")} elementId={"PublishingUnitId"}>
        
                <LookupDropdown
                    wrapperClassName="col-12 mb-2"
                    label={t("researchesCenter")}
                    service="courseOrderService"
                    endpoint="getManagementCentersDropdown"
                    onChange={(value) => {
                        setCentreManagementId(+value);
                    }}
                    value={centreManagementId}
                    textValueKey="centreManagementDetail.displayName"
                    idValueKey="id"
                    error={t(error ?? "")}
                    useReactSelect
                    isPaginated
                />
            </AccordionItem>
        </Accordion>
    );
}

export default CenterManagerSelect;